import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IIncidentReport, IIncidentReportLookupData, IDonorConnectIncidentLog, IIncidentReportRequest, IBaseResponse } from '@nkr/models/index';

export interface IIncidentReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IIncidentReport
    }
}

export interface IIncidentReportListResponse {
    data: {
        success: boolean,
        message: string,
        results: IIncidentReport[]
    }
}

export interface IIncidentReportLookUpResponse {
    data: {
        success: boolean,
        message: string,
        results: IIncidentReportLookupData
    }
}

export interface IIncidentReportLogResponse {
    data: {
        success: boolean,
        message: string,
        results: IDonorConnectIncidentLog
    }
}

export const ActionCreators = {
    getIncidentReportDetails: (incidentReportId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IIncidentReportResponse> => {
        let options = {
            url: `${__API__}/donor-connect/incident-report/${incidentReportId}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    // saveIncidentReport: (request: IIncidentReportRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IIncidentReportResponse> => {
    //     let options = {
    //         url: __API__ + '/center/incident-report',
    //         data: request
    //     }

    //     if (request.id == 0) {
    //         return await dispatch(AuthActionCreators.apiPost(options));
    //     } else {
    //         return await dispatch(AuthActionCreators.apiPut(options));
    //     }
    // },

    getIncidentReportLookupData: () => async (dispatch: Dispatch<IApplicationState>): Promise<IIncidentReportLookUpResponse> => {
        let options = {
            url: `${__API__}/donor-connect/incident-report/lookup-data`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getIncidentReportList: () => async (dispatch: Dispatch<IApplicationState>): Promise<IIncidentReportListResponse> => {
        let options = {
            url: `${__API__}/donor-connect/incident-report`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    saveIncidentReport: (request: IIncidentReportRequest) => async (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<IIncidentReportResponse> => {
        let options = {
            url: __API__ + '/donor-connect/incident-report',
            data: request
        }

        if (request.id == 0) {
            return await dispatch(AuthActionCreators.apiPost(options));
        } else {
            return await dispatch(AuthActionCreators.apiPut(options));
        }
    },

    saveIncidentLogEntry: (id: number, incidentReportId: number, actionTakenId: number, comments: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IIncidentReportLogResponse> => {
        let options = {
            url: `${__API__}/donor-connect/report-log-entry`,
            data: {
                id,
                incidentReportId,
                actionTakenId,
                comments
            }
        };

        if (id == 0)
            return await dispatch(AuthActionCreators.apiPost(options));
        else
            return await dispatch(AuthActionCreators.apiPut(options));
    },

    deleteIncidentLogEntry: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/donor-connect/report-log-entry/${id}`
        };

        return await dispatch(AuthActionCreators.apiDelete(options));
    },

    bulkMarkReviewedCompleted: (list: IIncidentReportRequest[]) => async (dispatch: Dispatch<IApplicationState>): Promise<IIncidentReportListResponse> => {
        let options = {
            url: `${__API__}/donor-connect/bulk-mark-reviewed-completed`,
            data: list
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
}